export const formatDate = (dateString) => {
  const date = new Date(dateString.replace(/-/g, "/"));
  const options = { day: "2-digit", month: "long", year: "numeric" };
  return new Intl.DateTimeFormat("es-ES", options).format(date);
};
